import React, { useEffect, useCallback } from "react";
import { connect } from "react-redux";
import * as actionsPresentacion from "../../../../actions/nuevaPresentacion";
import styles from "./styles";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import {
    Container,
    Typography,
    MenuItem,
    Tooltip,
    Box,
} from "@material-ui/core";
import { TextFieldCustom } from "../../../common/UI/Personalizaciones/TextField";

const DatosPrestador = ({ ...props }) => {
    const classes = styles();

    const codigoPrestadorHandleChange = (id) => {
        if (!props.soloVista && !props.esEdicion) {
            const prestador =
                props.prestador &&
                props.prestador.codigos.filter((el) => el.id === id)[0];

            props.seleccionarPrestador({ ...prestador });

            props.buscarDatosDeContactoUltimaPresentacion(
                prestador.codPrestador
            );

            props.actualizarRequeridosEsValido("codPrestador", true);
        }
    };

    const validarEmail = (email) => {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        const esValido = re.test(email.toLowerCase());

        props.actualizarRequeridosEsValido("emailContacto", esValido);

        const mensaje = "La dirección de email ingresada no es válida";
        props.actualizarMensajesError("email", !esValido ? mensaje : null);
    };

    const validarTelefono = (telefono) => {
        let esValido = false;

        if (telefono !== "" && !Number.isNaN(telefono)) {
            esValido = true;
        }

        props.actualizarRequeridosEsValido("telefonoContacto", esValido);

        const mensaje = "El número de teléfono ingresado no es válido";
        props.actualizarMensajesError("telefono", !esValido ? mensaje : null);
    };

    const filtrarCaracteresCampoNumerico = (event) => {
        if (event.key.toLowerCase() === "e" || event.key === ".") {
            event.preventDefault();
        }
    };

    // co

    const evaluarSeleccionarUnicoCodPrestador = useCallback(() => {
        if (props.prestador && props.prestador.codigos.length === 1) {
            const prestador = props.prestador.codigos[0];

            codigoPrestadorHandleChange(prestador.id);
        }
    }, [codigoPrestadorHandleChange]);

    useEffect(() => {
        evaluarSeleccionarUnicoCodPrestador();
    }, [props.prestador]);

    return (
        <Container disableGutters={true}>
            <Box className={classes.containerTituloPrincipal}>
                <Box className={classes.containerTitulo}>
                    <Typography className={classes.titulo}>
                        Datos del prestador
                    </Typography>
                    <Tooltip
                        placement="right"
                        title="Email donde recibirá aviso ante cualquier eventualidad con la presentación"
                    >
                        <Typography className={classes.ayuda}>?</Typography>
                    </Tooltip>
                </Box>
                <Typography className={classes.textoObligatorios}>
                    * Campos obligatorios
                </Typography>
            </Box>
            
            <div className={classes.container}>
                {props.prestador && (
                    <TextFieldCustom
                        id="codPrestadorSelect"
                        label="Código"
                        select={!props.soloVista}
                        variant="outlined"
                        size="small"
                        required={!props.soloVista}
                        className={classes.codPrestador}
                        disabled={props.esEdicion}
                        inputProps={{ readOnly: props.soloVista }}
                        SelectProps={{
                            IconComponent: (props) => (
                                <KeyboardArrowDownIcon
                                    fontSize="small"
                                    className={`${classes.dropDownIcon}, ${props.className}`}
                                />
                            ),
                        }}
                        onChange={(event) =>
                            codigoPrestadorHandleChange(event.target.value)
                        }
                        onBlur={() =>
                            props.actualizarMensajesError(
                                "codPrestador",
                                !props.prestadorSeleccionado
                                    ? "Debe seleccionar una opción"
                                    : null
                            )
                        }
                        error={!!props.errorMensaje.codPrestador}
                        helperText={
                            props.errorMensaje.codPrestador &&
                            props.errorMensaje.codPrestador
                        }
                        value={
                            props.prestadorSeleccionado
                                ? props.prestadorSeleccionado.codPrestador
                                : ""
                        }
                    >
                        {props.prestador.codigos.map((codigo) => (
                            <MenuItem key={codigo.id} value={codigo.id}>
                                {codigo.codPrestador}
                            </MenuItem>
                        ))}
                    </TextFieldCustom>
                )}
                <TextFieldCustom
                    // id="emailContacto"
                    // name="emailContacto"
                    label="Email"
                    variant="outlined"
                    // type="email"
                    size="small"
                    required={!props.soloVista}
                    className={classes.email}
                    value={props.emailContacto}
                    InputProps={{ readOnly: props.soloVista }}
                    disabled={props.esEdicion}
                    onChange={(event) => {
                        props.actualizarEmailContacto(event.target.value);
                    }}
                    onBlur={(event) => validarEmail(event.target.value)}
                    error={!!props.errorMensaje.email}
                    helperText={
                        props.errorMensaje.email && props.errorMensaje.email
                    }
                />
                <TextFieldCustom
                    id="telefonoContacto"
                    name="telefonoContacto"
                    label="Teléfono"
                    variant="outlined"
                    size="small"
                    required={!props.soloVista}
                    type="number"
                    className={classes.telefono}
                    value={props.telefonoContacto}
                    disabled={props.esEdicion}
                    inputProps={{ readOnly: props.soloVista }}
                    onChange={(event) =>
                        props.actualizarTelefonoContacto(event.target.value)
                    }
                    onKeyPress={(event) =>
                        filtrarCaracteresCampoNumerico(event)
                    }
                    onBlur={(event) => validarTelefono(event.target.value)}
                    error={!!props.errorMensaje.telefono}
                    helperText={
                        props.errorMensaje.telefono &&
                        props.errorMensaje.telefono
                    }
                />
            </div>
        </Container>
    );
};

const mapStateToProps = (state) => ({
    prestadorSeleccionado: state.nuevaPresentacionReducer.prestadorSeleccionado,
    prestador: state.authReducer.prestadorActivo,
    esEdicion: state.nuevaPresentacionReducer.esEdicion,
    soloVista: state.nuevaPresentacionReducer.soloVista,
    emailContacto: state.nuevaPresentacionReducer.emailResponsable,
    telefonoContacto: state.nuevaPresentacionReducer.telefonoResponsable,
    errorMensaje: state.nuevaPresentacionReducer.errorMensaje,
});

const actionCreators = {
    seleccionarPrestador: actionsPresentacion.seleccionarPrestador,
    actualizarEmailContacto: actionsPresentacion.actualizarEmailResponsable,
    actualizarTelefonoContacto:
        actionsPresentacion.actualizarTelefonoResponsable,
    buscarDatosDeContactoUltimaPresentacion:
        actionsPresentacion.buscarDatosDeContactoUltimaPresentacion,
    actualizarRequeridosEsValido:
        actionsPresentacion.actualizarRequeridosEsValido,
    actualizarMensajesError: actionsPresentacion.actualizarMensajesError,
};

export default connect(mapStateToProps, actionCreators)(DatosPrestador);
